import type { AbfWorkspaceKey } from './types/facilityWorkspace';

/** The one ABF home: a segmented control over Overview / Facilities / Forward-Flow. */
export const ABF_HOME_PATH = '/portfolio-management/credit/abf';
export type AbfHomeView = 'overview' | 'facilities' | 'forward-flow';
export const abfHomePath = (view: AbfHomeView = 'overview') =>
  view === 'overview' ? ABF_HOME_PATH : `${ABF_HOME_PATH}?view=${view}`;

export const ABF_WORKSPACE_ROOT = '/portfolio-management/credit/abf/facilities';
export const ABF_ONBOARDING_ROOT = '/portfolio-management/credit/abf/onboarding/versions';
export const ABF_FACILITY_ENTRY = '/portfolio-management/credit/abf/onboarding/new';
/** Slice 8: the portfolio board and the cross-facility work queue. */
export const ABF_BOARD_PATH = '/portfolio-management/credit/abf/board';
export const ABF_QUEUE_PATH = '/portfolio-management/credit/abf/queue';
export const ABF_RECIPIENTS_PATH = '/portfolio-management/credit/abf/recipients';
/** WS4: every contract-defined bank account across facilities, balances as of the last statement. */
export const ABF_ACCOUNTS_PATH = '/portfolio-management/credit/abf/accounts';
/** Item G (V697): the curated obligor master — LEI, aliases, merges, who matched how. */
export const ABF_OBLIGORS_PATH = '/portfolio-management/credit/abf/obligors';
/** WS6: fund-level reports and holder statements, keyed by fund and period. */
export const ABF_FORWARD_FLOW_PATH = '/portfolio-management/credit/abf/forward-flow';
export const forwardFlowProgramPath = (programId: number | string) => `${ABF_FORWARD_FLOW_PATH}/programs/${programId}`;

export const facilityWorkspacePath = (
  facilityId: number | string,
  workspace: AbfWorkspaceKey = 'overview',
) => `${ABF_WORKSPACE_ROOT}/${facilityId}/${workspace}`;

export const onboardingVersionPath = (versionId: number | string) =>
  `${ABF_ONBOARDING_ROOT}/${versionId}`;

/** Slice 6: the amendment review, one page for both lanes. */
export const amendmentReviewPath = (facilityId: number | string, versionId: number | string) =>
  `${ABF_WORKSPACE_ROOT}/${facilityId}/contract/amendments/${versionId}`;

/** Where a PDF amendment is uploaded (Document Processing, document class ABF_AMENDMENT). */
export const DOCUMENT_PROCESSING_PATH = '/middle-office?tab=document-processing';

export const isAbfWorkspaceKey = (value: string | undefined): value is AbfWorkspaceKey =>
  ['overview', 'contract', 'collateral', 'borrowing-base', 'funding', 'collections',
   'monitoring', 'valuation', 'reporting', 'documents', 'activity']
    .includes(value || '');
